export default __webpack_public_path__ + "static/media/top_nav_offers_small.2af5e162.svg";